import { MatterStatementLayout } from './layouts';
import { MatterStatementDashboardView } from './components/MatterStatementDashboardView';

export function MatterStatementDashboardPage() {
  return (
    <MatterStatementLayout>
      <MatterStatementDashboardView />
    </MatterStatementLayout>
  );
}
